<template>
	<ul class="community-contents-box">
		<li class="community-contents" v-for="(boardVO, i) in boardList" v-bind:key="boardType + i">
			<a @click="moveDetail(boardVO.boardIdx)">
				<p class="community-contents-title">
					<img class="icon-pin" :src="require('../../assets/images/icon/icon-pin@2x.png')" v-if="boardVO.stateNotice === 'Y'" />
					{{ boardVO.contentTitle }}
					<span class="board-new" v-if="boardVO.newYn === 'Y'">NEW</span>
				</p>
				<span class="community-contents-date" v-text="$moment(boardVO.regDate).format('YYYY-MM-DD')">2022-11-16</span>
			</a>
		</li>
	</ul>
</template>

<script>
export default {
	title: '커뮤니티 공지사항 리스트',
	name: 'CommunityNoticeList',
	data: function() {
		return {
			loginMember: null,
			boardType: 'notice',
			listPage: 1,
			boardList: [],
			totalCount: 0,
		};
	},
	created() {
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
	},
	mounted() {
		this.$nextTick(this.getBoardList.bind(this));
	},
	methods: {
		getBoardList: function() {
			this.boardList = [];
			let formData = new FormData();
			let boardTarget = this.loginMember.budsUserType;
			formData.append('boardTarget', boardTarget);
			formData.append('boardType', this.boardType);
			formData.append('page', this.listPage);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/board/getCommunityBoardList.do', formData)
				.then(res => {
					if (res.data.resultCode !== 0) {
						// window.alert(res.data.resultMsg);
						// this.$device.pushView('/board/notice');
					} else {
						this.boardList = res.data.data;
						this.totalCount = res.data.dataCount;
					}
				})
				.catch(e => {
					console.error(e);
					window.alert(e.message);
				});
		},
		moveDetail: function(boardIdx) {
			this.$device.pushView('/board/' + this.boardType + '/' + boardIdx);
		},
	},
};
</script>

<style scoped></style>
